export const AuthRole = {
  Administrator: "Administrator",
  WFH: "WFH",
  NMO: "NMO",
  DDC: "DDC",
};
